import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './components/Globals.js'
import './registerServiceWorker'
import VueAnalytics from 'vue-analytics'
import  VueCompositionApi from '@vue/composition-api'

Vue.config.productionTip = false
Vue.use(VueCompositionApi)
Vue.use(VueAnalytics, {
  id: 'UA-153883574-2',
  sendHitTask: process.env.NODE_ENV === 'production',
  router,
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
